import { CircularProgress, MenuItem, Skeleton, TextField, Autocomplete, Typography } from '@mui/material';
import { renderValueUserId } from '../../utils/utils';
import { Controller } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import { collection } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { useCollection } from 'react-firebase-hooks/firestore';

const FieldUserAutocomplete = ({ control, name, disabled, label, disableClear, setValue, rules }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const usersDocRef = collection(db, 'users');

  const [usersSnapshot, loadingRef] = useCollection(usersDocRef);
  // const [customersSnapshot, loading] = useCollectionData(customersDocRef);

  useEffect(() => {
    const fetchUsers = async () => {
      if (usersSnapshot) {
        const usersData = await Promise.all(
          usersSnapshot.docs.map(async (userDoc) => {
            const userData = userDoc.data();
            return { id: userDoc.id, ...userData };
          }),
        );
        setUsers(usersData);
        setLoading(false);
      }
    };
    // if (ordersSnapshot?.docs.length > 0) {
    //   const lastVisibleDoc = ordersSnapshot.docs[ordersSnapshot.docs.length - 1];
    //   setLastVisible(lastVisibleDoc);
    // }
    setLoading(true);
    fetchUsers().then();
    // console.log(customersSnapshot);
  }, [usersSnapshot]);

  if (loading)
    return (
      <Skeleton
        variant={'rounded'}
        animation="wave"
        sx={{
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomStyle: 'solid',
          borderBottomWidth: 1,
          borderBottomColor: 'divider',
        }}
        height={56}
      />
    );
  return (
    // <Controller
    //   name={name}
    //   defaultValue=""
    //   control={control}
    //   rules={rules}
    //   render={({ field }) => (
    //     <TextField
    //       {...field}
    //       label={label}
    //       variant="filled"
    //       fullWidth
    //       disabled={disabled}
    //       select
    //       slotProps={{
    //         input: {
    //           endAdornment:
    //             field.value && !disableClear ? (
    //               <InputAdornment position="end">
    //                 <IconButton
    //                   onClick={() => setValue(field.name, '')}
    //                   edge="end"
    //                 >
    //                   <Clear />
    //                 </IconButton>
    //               </InputAdornment>
    //             ) : null,
    //         },
    //       }}
    //       // slotProps={{
    //       //   input: {
    //       //     endAdornment: !loading ? (
    //       //       <CircularProgress
    //       //         color="inherit"
    //       //         size={24}
    //       //       />
    //       //     ) : null,
    //       //   },
    //       // }}
    //     >
    //       {customersSnapshot?.docs.map((doc) => {
    //         const customerSnap = doc.data();
    //         return (
    //           <MenuItem
    //             key={doc.id}
    //             value={doc.id}
    //           >
    //             {/*<ListItemIcon color={option.color}>{option.icon}</ListItemIcon>*/}
    //             <Typography variant="inherit">{renderValueCustomerId(customerSnap)}</Typography>
    //           </MenuItem>
    //         );
    //       })}
    //     </TextField>
    //   )}
    // />
    <Controller
      name={name}
      defaultValue=""
      control={control}
      rules={rules}
      render={({ field }) => {
        const selectedUser = users ? users.find((user) => user.id === field.value) : '';
        // console.log('selectedCustomer', selectedCustomer, customers);
        return (
          <Autocomplete
            loading={loading}
            disabled={disabled}
            disableClearable={disableClear}
            onChange={(event, newValue) => {
              return field.onChange(newValue ? newValue.id : '');
            }}
            value={selectedUser || null}
            options={users || []}
            autoComplete
            getOptionLabel={(option) => {
              return `${option.displayName}`;
            }}
            renderOption={(props, option) => (
              <MenuItem
                {...props}
                key={option.id}
                value={option.id}
              >
                {/*<ListItemIcon color={option.color}>{option.icon}</ListItemIcon>*/}
                <Typography variant="inherit">{renderValueUserId(option)}</Typography>
              </MenuItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                variant="filled"
                fullWidth
                disabled={disabled}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? (
                          <CircularProgress
                            color="inherit"
                            size={20}
                          />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  },
                }}
                // slotProps={{
                //   input: {
                //     endAdornment: !loading ? (
                //       <CircularProgress
                //         color="inherit"
                //         size={24}
                //       />
                //     ) : null,
                //   },
                // }}
              />
            )}
          />
        );
      }}
    />
  );
};

export default FieldUserAutocomplete;
